var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21L12 2l11 19H1zm3.45-2h15.1L12 6 4.45 19zM12 18a.968.968 0 00.713-.288A.967.967 0 0013 17a.967.967 0 00-.287-.712A.968.968 0 0012 16a.965.965 0 00-.712.288A.965.965 0 0011 17c0 .283.096.52.288.712A.965.965 0 0012 18zm-1-3h2v-5h-2v5z"
  })));
};
export default SvgWarning;